import React from "react";

import { DistributedEnergyResourceManagement } from "./components/distributed-energy-resource-management";
import { RethinkingTheGrid } from "./components/rethinking-the-grid";
import { ClientSideManagement } from "./components/client-side-management";
import { UtilityAdvantages } from "./components/utility-advantages";
import { HappyCustomers } from "./components/happy-customers";
import { EnvironmentalStewardship } from "./components/environmental-stewardship";
import { LetsBuildABetterGrid } from "./components/lets-build-a-better-grid";

export function Utilities() {
  return (
    <>
      <RethinkingTheGrid />
      <DistributedEnergyResourceManagement />
      <ClientSideManagement />
      <UtilityAdvantages />
      <HappyCustomers />
      <EnvironmentalStewardship />
      <LetsBuildABetterGrid />
    </>
  );
}
